import { render, staticRenderFns } from "./Selecttestcases.vue?vue&type=template&id=0445c8ac&scoped=true&"
import script from "./Selecttestcases.vue?vue&type=script&lang=js&"
export * from "./Selecttestcases.vue?vue&type=script&lang=js&"
import style0 from "./Selecttestcases.vue?vue&type=style&index=0&id=0445c8ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0445c8ac",
  null
  
)

export default component.exports